import { atom } from 'jotai';

import {
  type ClassModuleFilters,
  INITIAL_CLASS_MODULE_FILTERS,
} from '../../types/classModuleFilters';

/**
 * Átomo com o estado **aplicado** dos filtros da listagem de módulos.
 *
 * O `ClassModuleFilterBar` mantém o estado pendente localmente e só grava aqui
 * ao acionar "Buscar". Deve ser consumido apenas via `useClassModuleFilters`
 * (CLAUDE.md proíbe `useAtom` direto em componentes).
 */
export const classModuleFiltersAtom = atom<ClassModuleFilters>(INITIAL_CLASS_MODULE_FILTERS);
